<template>
  <div v-if="isPromoPanel" class="mt-5 py-4 flex promo-dbs-container">
    <span class="ml-4 flex-1 font-medium text-base">{{ $t("OrderPage[\"At Home Test\"]") }}</span>
    <el-switch 
      v-model="isDbs"
      class="dbs-toggle"
      active-color="#84BC3B" 
      inactive-color="#979797" 
      :active-text="$t('OrderPage[\'On\']')"
      :inactive-text="$t('OrderPage[\'Off\']')"
      :disabled="isAddOnOrder.length !== 0"
      @change="handleChangeEvent"
    />
  </div>
  <Alert v-else class="flex py-2" style="height:auto;">
    <div class="new-feature flex items-baseline">
      <slot name="content">
        <span>
          {{ "&nbsp;&nbsp;&nbsp;&nbsp;" + $t("OrderPage[\"Show only tests available for home collection\"]") }}
          <el-popover placement="bottom-start" popper-class="dbs-info-popover">
            <p class="dbs-popover-info">
              {{ $t("OrderPage[\"You can view tests that can be self-collected by the patients and will be shipped to the patient's home. This is more convenient, and you can order specials with Savings!\"]") }}
            </p>
            <template v-slot:reference>
              <span class="material-icons-outlined info-icon" style="position: relative; top: 3.7px;">info</span>
            </template>
          </el-popover>
        </span>
      </slot>
      <el-switch 
        v-model="isDbs"
        class="dbs-toggle"
        active-color="#84BC3B" 
        inactive-color="#979797" 
        :active-text="$t('OrderPage[\'On\']')"
        :inactive-text="$t('OrderPage[\'Off\']')"
        :disabled="isAddOnOrder.length !== 0"
        @change="handleChangeEvent"
      />
    </div>
  </Alert>
</template>

<script>
import Alert from "../../components/Alert.vue";
import { mapState } from "vuex";

export default {
  components: {
    Alert
  },
  props: {
    dbsToggle: {
      type: Boolean,
      default: false
    },
    isPromoPanel: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isDbs: this.dbsToggle
    }
  },
  computed: {
    ...mapState("orderTest", ["isAddOnOrder"]),
  },

  watch: {
    dbsToggle(newVal) {
      this.isDbs = newVal;
    }
  },
  emits: ["change"],
  methods: {
    handleChangeEvent(value) {
      this.$emit("change", value);
    }
  }
}
</script>

<style scoped>
.new-feature {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
}

.new-feature-text-color {
  color: #ff0000;
}

.dbs-popover-info {
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #ffffff;
  padding: 12px 15.5px 12px 15.5px;
  text-align: left;
}

.info-icon {
  margin-left: 2px;
  font-size: 20px;
  cursor: default;
  color: #000000;
  line-height: 0;
}

.dbs-toggle {
  margin-left: 80px;
  margin-right: 20px;
  height: auto;
}

.promo-dbs-container {
  border-radius: 8px;
  background: rgba(236, 42, 66, 0.05);
}
</style>